import { AppDatePicker } from "../../../core/AppDatePicker";
import { useFormikContext } from 'formik';
import moment from 'moment';
import { Box, FormGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractDateRangeFields = ({
  contract,
  ...stylingProps
}) => {
  const {
    errors,
    setFieldValue,
    setFieldTouched,
    touched,
    values
  } = useFormikContext();
  return /*#__PURE__*/_jsxs(Box, {
    $alignItems: "flex-start",
    $display: "flex",
    ...stylingProps,
    "data-sentry-element": "Box",
    "data-sentry-component": "ContractDateRangeFields",
    "data-sentry-source-file": "ContractDateRangeFields.tsx",
    children: [/*#__PURE__*/_jsx(FormGroup, {
      $flex: "1",
      htmlFor: "field-start-date",
      label: "Start date",
      required: true,
      error: touched.startDate && errors.startDate,
      ...stylingProps,
      "data-sentry-element": "FormGroup",
      "data-sentry-source-file": "ContractDateRangeFields.tsx",
      "data-sentry-element": "FormGroup",
      children: /*#__PURE__*/_jsx(AppDatePicker, {
        id: "field-start-date",
        maxDate: moment.utc().add(10, 'years').toDate(),
        onBlur: () => setFieldTouched('startDate'),
        onChange: date => {
          setFieldValue('startDate', moment(date).format('YYYY-MM-DD'));
        },
        value: moment.utc(values.startDate).toDate(),
        "data-sentry-element": "AppDatePicker",
        "data-sentry-source-file": "ContractDateRangeFields.tsx",
        "data-sentry-element": "AppDatePicker"
      })
    }), /*#__PURE__*/_jsx(Box, {
      $alignItems: "center",
      $boxSizing: "content-box",
      $display: "flex",
      $flex: "none",
      $height: "5sp",
      $justifyContent: "center",
      $pt: "3sp",
      $width: "6sp",
      as: "span",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ContractDateRangeFields.tsx",
      "data-sentry-element": "Box",
      children: "\u2014"
    }), /*#__PURE__*/_jsx(FormGroup, {
      $flex: "1",
      htmlFor: "field-end-date",
      label: "End date",
      required: true,
      error: touched.endDate && errors.endDate,
      ...stylingProps,
      "data-sentry-element": "FormGroup",
      "data-sentry-source-file": "ContractDateRangeFields.tsx",
      "data-sentry-element": "FormGroup",
      children: /*#__PURE__*/_jsx(AppDatePicker, {
        id: "field-end-date",
        maxDate: moment.utc().add(10, 'years').toDate(),
        minDate: values.startDate ? moment.utc(values.startDate).toDate() : undefined
        // onBlur={() => setFieldTouched('endDate')}
        ,
        onChange: date => {
          setFieldValue('endDate', moment(date).format('YYYY-MM-DD'));
        },
        value: values.endDate ? moment.utc(values.endDate).toDate() : undefined,
        "data-sentry-element": "AppDatePicker",
        "data-sentry-source-file": "ContractDateRangeFields.tsx",
        "data-sentry-element": "AppDatePicker"
      })
    })]
  });
};